/**
 * Expose global filters outside Angular
 * @param filterName
 * @returns {Function}
 */
function $filter(filterName) {
  switch(filterName) {
    case 'translate':
      return function(text) {
        return typeof lang !== "undefined" && lang[text] || text;
      }
  }
};

/**
 * Delete item from an array
 *
 * @param arr
 * @param index
 * @return the removed element or false.
 */
function ar_delete(arr, index) {
    var removedArray = arr.splice(index, 1);
    return ( removedArray.length > 0 ) ? removedArray[0] : false;
}

/**
 * Swap between two items in array
 *
 * @param array
 * @param index1
 * @param index2
 * @return array with the swapped elements
 */
function arraySwap(array, index1, index2) {
    var temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
    return array;
}


/**
 * Move an item in array
 *
 * @param arr
 * @param fromIndex
 * @param toIndex
 */
function ar_move(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}
/**
 * Insert element after
 *
 * @param arr
 * @param item
 * @param index
 *
 * @return newArray
 */
function ar_insert_after(arr, index, item) {
    return arr.splice(index, 0, item);
}

/**
 * // @TODO add docs ?
 *
 * @param array
 * @param id
 * @returns {*}
 */
function remove_value(array, id) {
    return _.reject(array, function (item) {
        return item == id;
    });
}

// @TODO add docs ?
/**
 *
 * @param options
 * @param callback
 */
function hConfirm(options, callback) {

	if (!angular.isObject(options)) {
		options = {
			text: options,
			callback: callback
		}
	}

	var settings = $.extend({
		title: '',
		text: '',
		callback: function () {
		},
		confirmButton: $filter("translate")("Yes"),
		cancelButton: $filter("translate")("Cancel"),
		confirmButtonClass: "",
		cancelButtonClass: "",
		dialogClass: "modal-dialog",
        datadogActionName: "",
        onHide: function () {
        }
	}, options);

    var modal = _bsModal({
        controller: 'HConfirmModalController',
        controllerAs: '$ctrl',
        templateUrl: "../scripts/global-directives/h-confirm-modal/h-confirm-modal.html",
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: function () {
                return {
                    dialogClass: settings.dialogClass,
                    title: settings.title,
                    text: settings.text,
                    cancelButtonClass: settings.cancelButtonClass,
                    cancelButton: settings.cancelButton,
                    confirmButtonClass: settings.confirmButtonClass,
                    confirmButton: settings.confirmButton,
                    datadogActionName: settings.datadogActionName,
                };
            },
            onHide: function () {
                return function () {
                    settings.onHide();
                }
            },
            onAction: function () {
                return function (confirmed) {
                    settings.callback(confirmed);
                }
            }
        }
    });

    return {
        close: modal.$scope.$hide
    }
}

// @TODO add docs ?
/**
 *
 * @param url
 */
function hRedirect(url) {
    console.warn("Redirect to:", url);
    window.location.href = url;
}

/**
 * Get url, with sub-domain updated based on given language
 * @param url
 * @param lang [optional]
 * @returns {*}
 */
function hGetUrl(url, lang) {
    if (lang) {
        var domain = window.location.hostname.replace("www.", "");
        var domainParts = domain.split(".");
        if (domainParts[0].length === 2) {
            domainParts[0] = lang;
            domain = domainParts.join(".");
        }
        else {
            domain = lang + "." + domain;
        }

        // Default is English, remove en.harri.com so it becomes harri.com
        url = url.replace(window.location.hostname, domain.replace("en.", ""));
    }

    return url;
}

/**
 * join_query_link
 * Example: join_query_link( 'http://harri.com' , {'ref': window.referer} );
 * @param link
 * @param params
 * @returns {*}
 */
function join_query_link(link, params){
    var segments = [], ext_link = '';

    for( var key in params){
        if( params[key] ){
            segments.push(key+'='+params[key])
        }
    }

    if( segments.length > 0 ){
        ext_link = segments.join('&');
    }
    else{
        return link;
    }

    return  (link.indexOf('?') == -1 )? link+'?'+ext_link : link+'&'+ext_link ;
}


/**
 * Get current page url, lang can be based to get sub-domain language related
 *
 * @param lang [optional]
 * @returns {*}
 */
function hGetCurrentUrl(lang) {
    return hGetUrl(window.location.href, lang);
}

/**
 * Return javascript object size.
 *
 * Refer to this page: http://stackoverflow.com/questions/5223/length-of-a-javascript-object-that-is-associative-array
 *
 * @param obj
 * @returns {number}
 */
function object_size(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
}
/***
 * Get query parameter
 * http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
function getParameterByName(name, link) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    link = link || location.search;
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(link);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 * getAddressLocation
 *
 * @returns {*|Window.location.href}
 */
function getAddressLocation() {
    return window.location.href;
}


/**
 * J O I N
 *
 * @param arr
 * @param key
 * @returns {*}
 */
function join_obj(arr, key) {
    if (arr && arr.length > 0) {
        return arr.map(function (item) {
            return item[key];
        }).join(",");
    }
    else {
        return "--";
    }
}

// Export to backend
// TODO: both frontend and backend should access utils methods from the Utils object
var Utils = {
    ar_delete: ar_delete,
    arraySwap: arraySwap,
    join_obj: join_obj,
    getAddressLocation: getAddressLocation,
    getParameterByName: getParameterByName,
    object_size: object_size,
    hConfirm: hConfirm,
    hAlert: hAlert
};

// Custom logging for errors
var hLog = function (page, section, exception) {

    try {
        exception = recursiveRemoveAttrs(exception, ['pass','password', 'card_number', 'old_password', 'new_password', 'confirm_new_password']);

        if (!(exception instanceof Error)) {
            exception = new Error(JSON.stringify(exception));
        }

        exception.message = "[hLog][" + page + "]" + "[" + section + "] " + exception.message;
        console.error(exception);
    }
    catch (e) {

    }

};

var getRGB = function(color) {
    return parseInt(color, 16) || color;
}

var getsRGB = function(color) {
    return getRGB(color) / 255 <= 0.03928 ? getRGB(color) / 255 / 12.92 : Math.pow((getRGB(color) / 255 + 0.055) / 1.055, 2.4);
}

var getLuminance = function(hexColor) {
    return (
        0.2126 * getsRGB(hexColor.substring(1, 3)) +
        0.7152 * getsRGB(hexColor.substring(3, 5)) +
        0.0722 * getsRGB(hexColor.substring(5, 7))
    );
}

var getContrast = function(bgColor, textColor) {
    var L1 = getLuminance(bgColor);
    var L2 = getLuminance(textColor);
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
}

var showSucessLintLO=null;

// Export to backend
if (typeof module !== 'undefined') {
    module.exports = Utils;
}

if(typeof window != "undefined"){
    window.Utils = Utils;
    window.$filter = $filter;
    window.ar_delete = ar_delete;
    window.arraySwap = arraySwap;
    window.ar_move = ar_move;
    window.ar_insert_after = ar_insert_after;
    window.remove_value = remove_value;
    window.hConfirm = hConfirm;
    window.hRedirect = hRedirect;
    window.hGetUrl = hGetUrl;
    window.join_query_link = join_query_link;
    window.hGetCurrentUrl = hGetCurrentUrl;
    window.object_size = object_size;
    window.getParameterByName = getParameterByName;
    window.getAddressLocation = getAddressLocation;
    window.join_obj = join_obj;
    window.keepAttrs = keepAttrs;
    window.removeAttrs = removeAttrs;
    window.recursiveRemoveAttrs =recursiveRemoveAttrs;
    window.getBaseURL =getBaseURL;
    window.createUUID = createUUID;
    window.goBack = goBack
    window.hPageConfirm = hPageConfirm;
    window.hAlert =hAlert;
    window.betterSomethingWentWrong = betterSomethingWentWrong;
    window.parseStateRefToUiSrefObj = parseStateRefToUiSrefObj;
    window.isDataEmpty = isDataEmpty;
    window.showServerError = showServerError;
    window.getScriptCcd = getScriptCcd;
    window.hLog = hLog;
    window.getRGB = getRGB;
    window.getsRGB = getsRGB;
    window.getLuminance = getLuminance;
    window.getContrast = getContrast;
    window.showSucessLintLO = showSucessLintLO;
    window.dateToYears = dateToYears;
    window.hasHttp = hasHttp;
    window.addQueryToURL = addQueryToURL;
    window.closeOffCanvas = closeOffCanvas;
    window.getVisibilityForJPLP = getVisibilityForJPLP;
    window.convertStringToVar = convertStringToVar;
    window.checkInputSupported = checkInputSupported;
    window.getAngularService = getAngularService;
    window.isIPhone = isIPhone;
    window.isSafari = isSafari;
    window.clearURL = clearURL;
    window.hideLoginModal = hideLoginModal;
    window.showLoginModal = showLoginModal;
    window.isBootstrapModalShown = isBootstrapModalShown;
    window.sanitizeString = sanitizeString;
    window.findIndexOf = findIndexOf;
    window.findBrandMediaByType = findBrandMediaByType;
    window.showSucessLint = showSucessLint;
    window.isInt = isInt;
    window.showLoading = showLoading;
    window.hideLoading = hideLoading;
    window.copy_object = copy_object;
    window.isRightClick = isRightClick;
    window.getWeekStart = getWeekStart;
    window.convertBetweenStateAndAbbreviation = convertBetweenStateAndAbbreviation;
    window.numbersToWords = numbersToWords;
}

Utils.downloadTrustIdAttachmentReport = function (trust_id_case, brand_id, callback) {
    EVerifyAPI.downloadReportByCase(brand_id, trust_id_case.user_id, trust_id_case.id)
        .then(function (res) {
            window.open(res,"_blank ");
        }, function (err) {
            hAlert($filter("translate")("Error"), $filter("translate")("A TrustID report cannot be found for this candidate") + ".");
        })
        .finally(function () {
            callback();
        });
};

Utils.validatePassword = function (password) {

    var result = {
        strength: 'weak',
        label: $filter('translate')('weak'),
        pass: false
    };

    var isValidLength = password.length>= 8;

    var englishNumbersRegex = /(?=.*[0-9])/;

    var specialCharsListRegex = /(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/])/;

    var nonAlphaNumericSymbolsRegex = /[^a-zA-Z0-9-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]+/;

    var upperCaseRegex = /[A-Z]+/;

    var lowerCaseRegex = /[a-z]+/;

    if (isValidLength) {


        if (nonAlphaNumericSymbolsRegex.test(password)) {
            if (specialCharsListRegex.test(password)) {
                result = {
                    strength: 'good',
                    label: $filter('translate')('good'),
                    pass: true
                };

                if (englishNumbersRegex.test(password)) {
                    result = {
                        strength: 'strong',
                        label: $filter('translate')('strong'),
                        pass: true
                    };
                }
            }
            else if (englishNumbersRegex.test(password)) {
                result = {
                    strength: 'good',
                    label: $filter('translate')('good'),
                    pass: true
                };
            }
        }
        else {

            var strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/])(?=.{8,})/;
            var mediumRegex = /^(((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]))|((?=.*[0-9])(?=.*[a-z])(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]))|((?=.*[0-9])(?=.*[A-Z])(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]))|((?=.*[a-z])(?=.*[A-Z])(?=.*[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/])))(?=.{8,})/;

            if(strongRegex.test(password)){

                result = {
                    strength: 'strong',
                    label: $filter('translate')('strong'),
                    pass: true
                };

            } else if(mediumRegex.test(password)){

                result = {
                    strength: 'good',
                    label: $filter('translate')('good'),
                    pass: true
                };
            }
        }
    }

    else {
        if(password.length === 0) {
            result = {
                strength: '',
                label: '',
                pass: false
            };
        }
        else {
            result = {
                strength: 'short',
                label: $filter('translate')('Too short'),
                pass: false
            };
        }
    }

    if (password.length !== password.trim().length) {
        result = {
            strength: 'invalid',
            label: $filter('translate')('Invalid Password'),
            pass: false
        };
    }

    result['hasUpperCase'] =  upperCaseRegex.test(password);
    result['hasLowerCase'] =  lowerCaseRegex.test(password);
    result['hasSpecialChars'] =  specialCharsListRegex.test(password);
    result['hasNumbers'] =  englishNumbersRegex.test(password);

    return result;
};


Utils.getPhoneRegx = function () {

    return /^\+?\(?([0-9]+)\)?([ .-]?)([0-9]+)([ .-]?)([0-9]+)([ .-]?)([0-9]+)$/;
};

Utils.getFileType = function ($file) {
    var fileType = $file.type;
    var fileName = $file.name || "";

    // In case of IE for PDF files
    if (!fileType) {
        if (fileName.toLowerCase().indexOf(".pdf") == fileName.length - 4) {
            fileType = 'application/pdf';
        }
    }

    return fileType;
};

Utils.isRetinaScreen = function() {
    if (typeof window != 'undefined' && window.devicePixelRatio) {
        return window.devicePixelRatio > 1;
    }
};

Utils.getFileSizeMB = function(file){
      return (file.size / (1024*1024));
};

Utils.checkFileSize = (file, sizeLimit) => {
    if (!file || file.size == 0) {
        hAlert($filter("translate")("Invalid file")+" \"" + file.name + "\"", $filter("translate")("File is no longer available or has a size of 0 Bytes."));
        return false;
    }

    const videoLimit = sizeLimit ?? 100; // MB
    const filesLimit = sizeLimit ?? 10; // MB

    const fileName = file.name || file.type.replace("/", ".");

    let selectedFileExt = fileName.split(".");
    selectedFileExt = selectedFileExt[selectedFileExt.length - 1];

    switch (selectedFileExt) {
        case 'mp4':
            if (file.size > videoLimit * 1024 * 1024) {
                hAlert($filter("translate")("Invalid file")+" \"" + fileName + "\"", $filter("translate")("Video is too large to be uploaded, maximum size allowed is") + videoLimit + ' ' + "MB.");
                return false;
            }
            break;
        default:
            if (file.size > filesLimit * 1024 * 1024) {
                hAlert($filter("translate")("Invalid file")+" \"" + fileName + "\"", $filter("translate")("File is too large to be uploaded, maximum size allowed is ") + filesLimit + ' ' +  "MB.");
                return false;
            }
            break;
    }

    return true;
};

Utils.stripTrailingSlash = function(str) {
    if(str.substr(-1) === '/') {
        return str.substr(0, str.length - 1);
    }
    return str;
};

Utils.async = function(cb) {
    setTimeout(cb, 1);
};


Utils.getDistanceFromLatLonInMiles = function(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = Utils.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = Utils.deg2rad(lon2 - lon1);
    var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(Utils.deg2rad(lat1)) * Math.cos(Utils.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d * 0.621371192; // distance in miles
};

Utils.deg2rad = function(deg) {
    return deg * (Math.PI / 180)
};

Utils.capitalize = function (string) {

    if (typeof(string) === "string") {
        string = string.toLowerCase();
        var stringParts = string.split(" ");
        for (var i in stringParts) {
            if (stringParts[i][0] &&
                (i == 0 || ['of', 'in', 'at', 'a', 'an', 'to', 'by', 'on', 'with', 'as', 'and', 'so', 'into', 'for', 'onto'].indexOf(stringParts[i]) == -1)
            ) {
                stringParts[i] = stringParts[i][0].toUpperCase() + stringParts[i].slice(1);
            }
        }

        string = stringParts.join(" ");
    }

    return string;
};

function keepAttrs(obj, attrs) {
    for (var k in obj) {
        var found = false;
        for (var kk in attrs) {
            if (attrs[kk] == k) {
                found = true;
            }
        }
        if (!found) {
            delete obj[k];
        }
    }
    return obj;
}

function removeAttrs(obj, attrs) {
    for (var k in obj) {
        var found = false;
        for (var kk in attrs) {
            if (attrs[kk] == k) {
                found = true;
            }
        }
        if (found) {
            delete obj[k];
        }
    }
    return obj;
}

function recursiveRemoveAttrs(obj, attrs) {

    if(angular.isObject(obj) || angular.isArray(obj)) {
        obj = removeAttrs(obj, attrs);

        for(var k in obj) {
            obj[k] = recursiveRemoveAttrs(obj[k], attrs);
        }
    }

    return obj;
}

Utils.windowOpener = function (callback, loadingText) {
    loadingText = loadingText || $filter('translate')('Loading...');
    let popupWindow = window.open(window.location, '_blank');
    popupWindow.document.write(`<div style="text-align: center; padding-top: 50vh;">${loadingText}</div>`);
    callback.then(url => {
        popupWindow.location.href = url;
    }, error => {
        popupWindow.close();
    });
}

/* return website BaseURL */

function getBaseURL(){

    var base_url = window.location.origin;

    return base_url;
}

/**
 * Generate random id
 * See here: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
function createUUID() {
    // http://www.ietf.org/rfc/rfc4122.txt
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}


/**
 * Go Back
 */
function goBack() {
    window.history.back();
}
function hPageConfirm($appModal, $state, exitCallback) {
    $appModal.modal('show').on('show.bs.modal', function (e) {
        $appModal.unbind('hide.bs.modal')
            .unbind('hidden.bs.modal')
            .unbind('show.bs.modal')
            //ask before quiting modal
            .on('hide.bs.modal', function (e) {
                //detect hide event associated with a namespace and click event type (window.event.type = click)
                if (e.type == "hide" && e.namespace == "bs.modal") {

                    hConfirm($filter("translate")("Are you sure you want to leave this page?"), function (result) {
                        if (result) {
                            $appModal.unbind('hide.bs.modal').modal('hide').one('hidden.bs.modal', function () {
                                if (exitCallback) {
                                    exitCallback();
                                } else {
                                    $state.go('^');
                                }
                            });
                        }
                    });

                }
                else if (e.namespace != "" && window.event && window.event.type) {
                    $state.go('^');
                }
                return false;
            });
    });

    if ($('body.mobile-view').hasClass('modal-open')) {
        $('body').removeClass('modal-open');
    }
}

//http://lions-mark.com/jquery/scrollTo/

//node.js can't understand $
try {
    $.fn.scrollTo = function (target, options, callback) {
        if (typeof options == 'function' && arguments.length == 2) {
            callback = options;
            options = target;
        }
        var settings = $.extend({
            scrollTarget: target,
            offsetTop: 50,
            duration: 500,
            easing: 'swing'
        }, options);
        return this.each(function () {
            var scrollPane = $(this);
            var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : $(settings.scrollTarget);
            var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
            scrollPane.animate({scrollTop: scrollY }, parseInt(settings.duration), settings.easing, function () {
                if (typeof callback == 'function') {
                    callback.call(this);
                }
            });
        });
    }
} catch (e) {
}

function hAlert(titleOrOptions, textOrCallback, onHide, customClass, appendTo, onShow, id, withoutBodyClass) {

    /**
     * Random id for alert modal
     *
     * @type {*|string}
     */
    id = id || ('h-custom-alert' + Date.now());

    /**
     * Default options for modal
     */
    var options = {
        title: '',
        text: '',
        custom_class: '',
        button: null
    };

    /**
     * This to append the modal to some element not to body
     * Body is the default
     *
     * @type {*|string}
     */
    appendTo = appendTo || 'body';

    /**
     * Simple check to handle if the first argument is text or object
     */
    if (typeof(titleOrOptions) === 'object') {
        options = $.extend(options, titleOrOptions);
        onHide = textOrCallback;
    }
    else {
        options['title'] = titleOrOptions;
        options['text'] = textOrCallback;
        options['custom_class'] = customClass;
    }

    options['id'] = id;
    options['withoutBodyClass'] = withoutBodyClass;

    var prefixEvent = "modal" + Date.now();

    var modal = _bsModal({
        controller: 'HAlertModalController',
        controllerAs: '$ctrl',
        templateUrl: "../scripts/global-directives/h-alert-modal/h-alert-modal.html",
        show: true,
        prefixEvent: prefixEvent,
        backdrop: 'static',
        resolve: {
            modalData: function () {
                return options;
            }
        }
    });

    modal.$scope.$on(prefixEvent + '.hide.before', function (e) {
        onHide && onHide(e);
    });

    modal.$scope.$on(prefixEvent + '.show', function (e) {
        if (options.withoutBodyClass) {
            $('body').removeClass('modal-open');
        }

        if (options['button'] && options['button']['on_confirm']) {
            modal.$element.find('.confirm-btn').on('click', function (e) {
                options['button']['on_confirm'](e);
                modal.$scope.$hide();
            });
        }

        onShow && onShow(e);
    });

    return {
        close: modal.$scope.$hide
    }
}

function betterSomethingWentWrong(){
    hAlert("Error" + "!", $filter("translate")("Something went wrong, please try again later. If the problem persists," +
        " contact our stellar support team here (support@harri.com) " +
        "or dial US: +1.844.427.7443  |  " +
        "UK: +44 800 260 6489"));
}

function parseStateRefToUiSrefObj(ref, current) {
    var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
    if (preparsed) ref = current + '(' + preparsed[1] + ')';
    parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
    return { state: parsed[1], paramExpr: parsed[3] || null };
}

function isDataEmpty(data) {
    return angular.equals({}, data) || (angular.equals([], data)) || (angular.equals([
        []
    ], data))
}


/**
 * check if server has error and show it
 * @param resp
 */
function showServerError(resp) {
    if (resp.status_code != 200 && resp[0] && resp[0].error) {
        hAlert("Error!", resp[0].error);
    }
}


function getScriptCcd(url, callback) {
    jQuery.ajax({
        type: "GET",
        url: url,
        success: callback,
        dataType: "script",
        cache: true
    });
}

function dateToYears(start_date, end_date) {
    var end_date = end_date ? end_date : new Date();
    var msec = end_date - new Date(start_date);
    return Math.floor(Math.floor(msec / 1000 / 60 / 60 / 24 / 360));
}

function hasHttp(link) {
    return /^[\s]*http(s)?\:/.test(link);
}


function closeOffCanvas(){
  $('.navmenu.offcanvas-clone').remove();
  if($('.navmenu').is(':visible')){
    $('.navmenu').offcanvas('hide');
  }
}

function getVisibilityForJPLP() {

    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    isMobile = isMobile.matches;
    /* Visibility
    ============================================*/
    var visibility = {};
    visibility.skills = {};
    visibility.details = {};

    /* Skills
    ====================*/
    visibility.skills.count_visible = 2;
    visibility.skills.collapsed = false;

    var HeighWidthVariations = $(window).height()/$(window).width();
    //console.log('isMobile',isMobile);
    //console.log('HeighWidthVariations',$(window).height(),HeighWidthVariations);
    /* Details
    ====================*/
    visibility.details.count_visible = 2;
    visibility.details.collapsed = false;

    if(isMobile){
      visibility.details.collapsed = true;
    }
    //Check for Retina Screens
    if ((typeof window != 'undefined' &&
        window.devicePixelRatio &&
        window.devicePixelRatio > 1 ) || HeighWidthVariations > 0.65 ) {
        visibility.skills.count_visible = 4;
        visibility.details.count_visible = 4;
    }

    return visibility;
}

function convertStringToVar(string) {
	return string.replace(/[^\w]/g,'')
}


function checkInputSupported(inputType) {
  var i = document.createElement("input");
  i.setAttribute("type", inputType);
  return i.type !== "text";
}

function getAngularService(angularService) {
    //get the service.
    return  $injector.get(angularService);
}

/**
 * Validate Minimum Image Size from $file
 *
 * @param $file
 * @param size
 * @param cb
 */
Utils.validateMinSizeImageFromFile = function($file, size,cb) {
    var reader = new FileReader;
    reader.onload = function () {
        var image = new Image();

        image.src = reader.result;

        image.onload = function () {
            if (image.width < size.width || image.height < size.height) {
                hAlert($filter("translate")("The photo you uploaded is too small!"), $filter("translate")("It must be at least")+' ' + size.width + ' '+$filter("translate")("pixels width and")+' ' + size.height + ' '+$filter("translate")("pixels height."));
            }
            else {
                cb();
            }
        };

    };
    reader.readAsDataURL($file);
}
function addQueryToURL(url,query,validateExistance) {

    // Work arround to fix UTM params in iframeUrl's
    if (url.indexOf("/{iframeUrl") == 0) {
        url = url + "?" + query;
    }
    else {
        if(url.indexOf(validateExistance) >= 0) {
            return url;
        } else if(url.indexOf('?') >= 0) {
            url = url + "&" + query;
        } else if(url.indexOf('?') < 0) {
            url = url + "?" + query;
        }
    }

    return url;

}


/**
 * Check if the current user agent is iphone or not.
 *
 * @returns {string[]}
 */
function isIPhone(){
     return navigator.userAgent.match(/iPhone/i);
}


/**
 * Check if the current user agent is iphone or not.
 *
 * @returns {string[]}
 */
function isSafari(){
    return navigator.userAgent.indexOf("Safari") > -1;
}


/**
 * clear url
 * @param url
 * @returns {*}
 */
function clearURL(url){
  if( url && typeof url == "string"){
    return url.replace('http://www.','').replace('http://','');
  }

  return "";
}


/*
* hide the login modal & provide some fallbacks where
* bootstrap modal functions might not work properly (currently the timeout used)
*
*/
function hideLoginModal(){

  if(isBootstrapModalShown('#login-modal')){
    $timeout(function(){
      $("#login-modal .modal").modal("hide");
    });
  }

}

/*
 * show the login modal & provide some fallbacks where
 * bootstrap modal functions might not work properly (currently the timeout used)
 *
 */
function showLoginModal(){

  if(!isBootstrapModalShown('#login-modal')){
    $timeout(function(){
      $("#login-modal .modal").modal("show");
    }, 100);
  }

}


/*
* check if a bootstrap modal is shown
* src: http://stackoverflow.com/a/21341587
*
* @param {String} modalSelector
* @return {Boolean} shown
*/
function isBootstrapModalShown(modalSelector){

    return ($(modalSelector).find(".modal").data('bs.modal') || {}).isShown;

}

/*
 * Sanitize String - clean text
 * src: http://stackoverflow.com/a/21341587
 *
 * @param {String} str
 * @return {string}
 */
function sanitizeString(str){

  str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");

  return str.trim();

}



function findIndexOf(collection, filter) {
    for (var i = 0; i < collection.length; i++) {
        if(filter(collection[i], i, collection)) return i;
    }
    return -1;
}

/* this function will return media by type
---------
 */

function findBrandMediaByType(brandMedia, type){

    brandMedia = brandMedia || [];
    return _.find(brandMedia, function(media){ return media.type == type; });

}

function showSucessLint(msg, to){
    $('#success-lint').remove();
    $('body').append('<div class="success-lint padding-xs" id="success-lint" ng-show="tagAddedSuccessfully">'+
            ' <i class="fa fa-check-circle-o"></i> '+msg+ '</div>');
    $('#success-lint').css('margin-left', '-' + parseInt( $('#success-lint').width() / 2) +'px');

    if(showSucessLintLO){
        clearTimeout(showSucessLintLO);
    }

    $($('#success-lint')[0]).click(function(){
        clearTimeout(showSucessLintLO);
        $('#success-lint').remove();
    });

    showSucessLintLO = setTimeout(function(){
        $('#success-lint').remove();
    }, to || 3000);
}

/*
http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript

isInt(42)        // true
isInt("42")      // true
isInt(4e2)       // true
isInt("4e2")     // true
isInt(" 1 ")     // true
isInt("")        // false
isInt("  ")      // false
isInt(42.1)      // false
isInt("1a")      // false
isInt("4e2a")    // false
isInt(null)      // false
isInt(undefined) // false
isInt(NaN)       // false
 */
function isInt(value) {
  return !isNaN(value) &&
         parseInt(Number(value)) == value &&
         !isNaN(parseInt(value, 10));
}

function showLoading(){
    $('#loading-indicator').remove();
    $('body').append('<div id="loading-indicator" class="loading-indicator"> '+ $filter('translate')('Loading..')+ ' </div>');
}

function hideLoading() {
  $('#loading-indicator').remove();
}


function copy_object(o){
    return JSON.parse( JSON.stringify( o ) );
}


/* Cretae a color from string
src: http://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript
 */

Utils.stringToColor = function (str){
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
};

Utils.capitalizeFirstLetter = (string) => {
    return string.charAt(0) + string.slice(1).toLowerCase();
}

Utils.userToBgColor = function (member, returnAsString){
    member = member || {};
    var color;

    if (returnAsString) {
        color =  '#' + Utils.stringToColor(member.id + '-' + member.first_name + '-' + member.last_name);
    } else {
        color = 'background-color: ' + '#' +
            Utils.stringToColor(member.id + '-' + member.first_name + '-' + member.last_name);
    }

    return color;
};

Utils.stringToBackgroundColor = function (str) {
    return 'background-color: #' + Utils.stringToColor(str);
};

Utils.firstChar = function (value){
    if (value) {
        return value.substr(0, 1);
    }

    return "";
};

Utils.jsonToHTML = function (data, smartFields) {
    if(!data.tag) {
        return '';
    }
    let childrenContent = '';
    let attributes = '';
    let content = '';
    if (data.children && data.children.length) {
        for (let i in data.children) {
            childrenContent += Utils.jsonToHTML(data.children[i], smartFields);
        }
    }
    content = data.content || childrenContent;

    if (data.attributes && data.attributes.length) {
        for (let j in data.attributes) {
            attributes += ' ' + data.attributes[j].name + '="' + data.attributes[j].value + '"';
        }
    }
    switch (data.tag) {
        case 'text':
            return content;
        case 'br':
        case 'input':
            return '<' + data.tag + attributes + '/>';
        case 'span':
            let spanAttributes = _.pluck(data.attributes, 'name');
            let fieldCodeIndex = spanAttributes.indexOf('field-code');
            if (fieldCodeIndex > -1) {
                let fieldCode = data.attributes[fieldCodeIndex].value;
                let smartFieldsCodes = _.pluck(smartFields, 'code');
                if (smartFieldsCodes.indexOf(fieldCode) == -1) {
                    return '';
                } else {
                    return '<' + data.tag + attributes + '>' + content + '</' + data.tag + '>';
                }
            } else {
                return '<' + data.tag + attributes + '>' + content + '</' + data.tag + '>';
            }
        default:
            return '<' + data.tag + attributes + '>' + content + '</' + data.tag + '>';
    }
};

Utils.htmlToJson = function (htmlNodeOrString) {
    let rootNode = (typeof htmlNodeOrString === 'string') ? $('<div>' + htmlNodeOrString + '</div>' )[0] : htmlNodeOrString;
    if (rootNode.nodeType === Node.TEXT_NODE) {
        return {tag: "text", content: Utils.htmlEntities(rootNode.textContent || "")};
    }

    if (rootNode.nodeType === Node.ELEMENT_NODE) {
        let nodesChildren = [];
        for (let i = 0; i < rootNode.childNodes.length; i++) {
            nodesChildren.push(Utils.htmlToJson(rootNode.childNodes[i]))
        }
        let nodesAttributes = [];
        for (let j = 0; j < rootNode.attributes.length; j++) {
            let attr = rootNode.attributes[j];
            nodesAttributes.push({"name": attr.name, "value": attr.value})
        }

        if (rootNode.tagName.toLowerCase() == 'td') {
            let tdHeight = $(rootNode).height();
            let tdWidth = $(rootNode).width();
            nodesAttributes.push({"name": 'style', "value": "height=" + tdHeight + "px; width=" + tdWidth + "px;"})
        }

        return {
            tag: rootNode.tagName.toLowerCase(),
            children: nodesChildren,
            attributes: nodesAttributes
        };
    }
    return {};
};

Utils.mergeColors = function (color1, color2, ratio1) {
    color1 = color1.replace("#", "");
    color2 = color2.replace("#", "");
    ratio1 = !isNaN(ratio1)? ratio1: 0.5;
    var ratio2 = (1 - ratio1);

    var color1Partials = {
        'red': parseInt('0x' + color1.substr(0, 2)),
        'green': parseInt('0x' + color1.substr(2, 2)),
        'blue': parseInt('0x' + color1.substr(4, 2))
    };

    var color2Partials = {
        'red': parseInt('0x' + color2.substr(0, 2)),
        'green': parseInt('0x' + color2.substr(2, 2)),
        'blue': parseInt('0x' + color2.substr(4, 2))
    };

    var resultingColor = {
        'red': Math.round(ratio1 * color1Partials['red'] + ratio2 * color2Partials['red']),
        'green': Math.round(ratio1 * color1Partials['green'] + ratio2 * color2Partials['green']),
        'blue': Math.round(ratio1 * color1Partials['blue'] + ratio2 * color2Partials['blue'])
    };

    return ('#' + ('00' + resultingColor.red.toString(16)).slice(-2)
        + ('00' + resultingColor.green.toString(16)).slice(-2)
        + ('00' + resultingColor.blue.toString(16)).slice(-2)).toUpperCase();
};


Utils.hexToRGB = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return [
        "rgb(",
        parseInt(result[1], 16),
        ",",
        parseInt(result[2], 16),
        ",",
        parseInt(result[3], 16),
        ")"
    ].join('');
};

//send color with hexadecimal and #
Utils.getPreferredTextColor = function(bgColor) {
    var whiteContrast = getContrast(bgColor, '#ffffff');
    var blackContrast = getContrast(bgColor, '#000000');
    return whiteContrast > blackContrast ? '#ffffff' : '#000000';
}
/*
  Check if right click
 */

function isRightClick(e) {
  if (e.which) {
    return (e.which == 3);
  } else if (e.button) {
    return (e.button == 2);
  }
  return false;
}

//Get start of the week given week day & date
//startOfWeekDay options: Sunday Monday ... Friday Saturday
function getWeekStart(date, startOfWeekDay) {
    if (!date || !date.isValid()) {
        console.warn('Invalid date', date);
        return;
    }

    date = date.clone();

    var originalHours = date.hours();

    date.hours(12);
    date.locale("en");

    if (date.format("ddd").toUpperCase() == startOfWeekDay.toUpperCase()) {
        return date.hours(originalHours).locale(moment.locale());
    }

    while (date.format("ddd").toUpperCase() != startOfWeekDay.toUpperCase()) {
        date = date.clone().subtract(1, 'days');
    }

    return date.hours(originalHours).locale(moment.locale());
}

Utils.getWeekStart = getWeekStart;

/**
 * convert between state name and state Abbreviation
 */

function convertBetweenStateAndAbbreviation (state, stateOrAbbrev) {
    var convertedString;

    if (state) {
        for (var i in US_STATES) {
            if (state.toLowerCase() == US_STATES[i][(stateOrAbbrev)? "name" : "abbreviation"].toLowerCase()) {
                convertedString = US_STATES[i][(stateOrAbbrev)? "abbreviation" : "name"];
                break;
            }
        }
    }

    return (convertedString)? convertedString : state;
}

Utils.convertCountryBetweenAbbrevAndCode = function (country, codeOrAbbrev) {
    var convertedString;

    if (country) {
        for (var i in NATIONALITY_CODES) {
            var fieldValue = (codeOrAbbrev)? i : NATIONALITY_CODES[i];

            if (country.toLowerCase() === fieldValue.toLowerCase()) {
                convertedString = (codeOrAbbrev)? NATIONALITY_CODES[i] : i;
                break;
            }
        }
    }

    return (convertedString)? convertedString : fieldValue;
};


Utils.isEmailForCategory = function (email, category) {
    var listOfDomains = [];
    var radissionDomains = [
        'firelakerestaurant.com',
        'gandvhotel.com',
        'hormuzgrandhotel.com',
        'okoumepalace.com',
        'parkinn.com',
        'quorvuscollection.com',
        'radisson-hotels.ru',
        'radisson.kz',
        'radisson.ru',
        'radissonblu.com',
        'radissoncollection.com',
        'radissonhotels.com',
        'radissonred.com',
        'rezidor.com',
        'rezidorhotels.com',
        'rezidorparkinn.com',
        'rezpin.com',
        'stockholmwaterfront.com',
        ' symphonystylehotel.com'
    ];

    if (category == 'RADISSON') {
        listOfDomains = radissionDomains;
    }
    if (email) {
        var value = email.toLowerCase();
        for (var i in listOfDomains) {
            if (value.indexOf('@' + listOfDomains[i]) > 0) {
                return true;
            }
        }
    }
    return false;
};


/* convert numbers to string */
//src: http://stackoverflow.com/questions/14766951/convert-digits-into-words-with-javascript
function numbersToWords(num) {
    if(!num) {
        return;
    }

    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    if ((num = num.toString()).length > 9) {
        console.error("can't handle number larger than 9 digits");
        return 'overflow';
    }
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) {
        return;
    }

    var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Billion ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'million ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]): '';

    return str;
}

Utils.downloadFileWithBOM = function(data, fileName, contentType) {
    /**
     * Use of a BOM is neither required nor recommended for UTF-8, but may
        be encountered in contexts where UTF-8 data is converted from other encoding forms that
        use a BOM or where the BOM is used as a UTF-8 signature.
        http://www.unicode.org/versions/Unicode5.0.0/ch02.pdf
     */
    return Utils.downloadFile("\ufeff"+data, fileName, contentType);
};

Utils.downloadFile = function (data, fileName, contentType) {
    contentType = contentType || "application/octet-stream";
    var blobObject = new Blob([data], {type: contentType + ";charset=UTF-8"});
    try {
        window.navigator.msSaveOrOpenBlob(blobObject, fileName);
    }
    catch (exp) {
        var link = document.createElement('a');
        link.setAttribute('href', URL.createObjectURL(blobObject));
        link.setAttribute('download', fileName);
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
    }
};

Utils.downloadFileFromUrl = function (url, inNewTab) {
    var link = document.createElement('a');
    if (inNewTab) {
        link.target = '_blank';
    }
    link.setAttribute('href', url);
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
};

Utils.trimTextBasedOnHeight = function(elm, height) {
    if (elm.height() > height) {
        var text = elm.text();
        elm.text(text.substring(0, text.length - 2));
        Utils.trimTextBasedOnHeight(elm, height);
        return true;
    }
};

Utils.isValidJson = function (jsonString) {
    try {
        JSON.parse(jsonString);
        return true;
    } catch (error) {
        return false;
    }
}

Utils.getISODate = function(date){
    return date.format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
};

/**
 * round the value to the nearest fraction based on the multiplier.
 * @param {number} value the value to round.
 * @param {number} multiplier the multiplier that represent what is the fraction to round to, examples:
 * - 1 -> round to the nearest integer.
 * - 2 -> round to the nearest half.
 * - 4 -> round to the nearest quarter.
 * @returns {number} rounded value.
 */
Utils.roundToNearestFraction = function (value, multiplier) {
    return Math.round(value * multiplier) / multiplier;
};

/**
 * floor the value to the nearest fraction based on the multiplier.
 * @param {number} value the value to round.
 * @param {number} multiplier the multiplier that represent what is the fraction to floor to, examples:
 * - 1 -> floor to the nearest integer.
 * - 2 -> floor to the nearest half.
 * - 4 -> floor to the nearest quarter.
 * @returns {number} rounded value.
 */
Utils.floorToNearestFraction = (value, multiplier) => {
    return Math.floor(value * multiplier) / multiplier;
};

/**
 * ceil the value to the nearest fraction based on the multiplier.
 * @param {number} value the value to round.
 * @param {number} multiplier the multiplier that represent what is the fraction to ceil to, examples:
 * - 1 -> ceil to the nearest integer.
 * - 2 -> ceil to the nearest half.
 * - 4 -> ceil to the nearest quarter.
 * @returns {number} rounded value.
 */
Utils.ceilToNearestFraction = (value, multiplier) => {
    return Math.ceil(value * multiplier) / multiplier;
};

Utils.roundFloat = function (number, fractions) {
    fractions = isNaN(fractions)? 2: fractions;
    var factor = Math.pow(10, fractions);
    return Math.round(number * factor) / factor;
};

Utils.isValidNumber = function (number) {
    return !isNaN(number) && !isNaN(parseFloat(number));
};

Utils.floorFloat = function (number, fractions) {
    fractions = isNaN(fractions)? 2: fractions;
    var factor = Math.pow(10, fractions);
    return Math.floor(number * factor) / factor;
};

Utils.getWordsInitialChars = function (word) {
    var name =  word || "";
    var nameSplit = name.toString().split(" ");

    var firstChar = nameSplit[0][0] || "";
    var secondChar = nameSplit[0][1] || "";
    var lastChar =  nameSplit[nameSplit.length - 1][0] || "";

    var result =  firstChar + ((nameSplit.length > 1) ? lastChar : secondChar);
    result = result || "";

    return result.toUpperCase();
};

Utils.getSubTextForLangDetection = function (text, type) {
    text = text || "";
    var textLines = text.replace(/\t/g, " ").replace(/[\•\●]/g, "").trim().split("\n");
    var textToTranslate = "";

    for (var i in textLines) {
        var line = textLines[i];
        var words = line.split(" ");
        var startIndex = 0;

        for (var j in words) {
            var index = parseInt(j);
            if (index >= 2 && words[index].indexOf('..') === -1 && words[index].length > 2) {
                if (words[index - 1] && words[index - 2]) {
                    startIndex = index - 2;
                    break;
                }
            }
        }

        var wordsToTranslate = type? 6: 3;
        var proposedText = words.slice(startIndex, startIndex + wordsToTranslate).join(" ");

        if (proposedText.length > textToTranslate.length) {
            textToTranslate = proposedText;
        }
    }

    textToTranslate = textToTranslate || text;
    return textToTranslate.substr(0, 50);
};

Utils.currencyCodeToSymbol = function (code) {
    let currencySymbolMap = {
        'ALL': 'Lek',
        'AFN': '؋',
        'ARS': '$',
        'AWG': 'ƒ',
        'AUD': '$',
        'AZN': '₼',
        'BSD': '$',
        'BBD': '$',
        'BYN': 'Br',
        'BZD': 'BZ$',
        'BMD': '$',
        'BOB': '$b',
        'BAM': 'KM',
        'BWP': 'P',
        'BGN': 'лв',
        'BRL': 'R$',
        'BND': '$',
        'KHR': '៛',
        'CAD': '$',
        'KYD': '$',
        'CLP': '$',
        'CNY': '¥',
        'COP': '$',
        'CRC': '₡',
        'HRK': 'kn',
        'CUP': '₱',
        'CZK': 'Kč',
        'DKK': 'kr',
        'DOP': 'RD$',
        'XCD': '$',
        'EGP': '£',
        'SVC': '$',
        'EUR': '€',
        'FKP': '£',
        'FJD': '$',
        'GHS': '¢',
        'GIP': '£',
        'GTQ': 'Q',
        'GGP': '£',
        'GYD': '$',
        'HNL': 'L',
        'HKD': '$',
        'HUF': 'Ft',
        'ISK': 'kr',
        'INR': '₹',
        'IDR': 'Rp',
        'IRR': '﷼',
        'IMP': '£',
        'ILS': '₪',
        'JMD': 'J$',
        'JPY': '¥',
        'JEP': '£',
        'KZT': 'лв',
        'KPW': '₩',
        'KRW': '₩',
        'KGS': 'лв',
        'LAK': '₭',
        'LBP': '£',
        'LRD': '$',
        'MKD': 'ден',
        'MYR': 'RM',
        'MUR': '₨',
        'MXN': '$',
        'MNT': '₮',
        'MZN': 'MT',
        'NAD': '$',
        'NPR': '₨',
        'ANG': 'ƒ',
        'NZD': '$',
        'NIO': 'C$',
        'NGN': '₦',
        'NOK': 'kr',
        'OMR': '﷼',
        'PKR': '₨',
        'PAB': 'B/.',
        'PYG': 'Gs',
        'PEN': 'S/.',
        'PHP': '₱',
        'PLN': 'zł',
        'QAR': '﷼',
        'RON': 'lei',
        'RUB': '₽',
        'SHP': '£',
        'SAR': '﷼',
        'RSD': 'Дин.',
        'SCR': '₨',
        'SGD': '$',
        'SBD': '$',
        'SOS': 'S',
        'ZAR': 'R',
        'LKR': '₨',
        'SEK': 'kr',
        'CHF': 'CHF',
        'SRD': '$',
        'SYP': '£',
        'TWD': 'NT$',
        'THB': '฿',
        'TTD': 'TT$',
        'TRY': '₺',
        'TVD': '$',
        'UAH': '₴',
        'AED': 'د.إ',
        'GBP': '£',
        'USD': '$',
        'UYU': '$U',
        'UZS': 'лв',
        'VEF': 'Bs',
        'VND': '₫',
        'YER': '﷼',
        'ZWD': 'Z$'
    };
    return currencySymbolMap[code] || code;
}

Utils.locationCurrencySymbol = function (brand) {
    var location;
    var country;

    if (brand) {

        // HARRI-33820: Support a fixed add-on currency for Radisson Switzerland
        var radissonSwitzerlandBrandIds = [1403334, 1404436, 1407646, 1403355, 1403354, 1404437, 1404438, 1403397, 1404439, 1403415, 1404440, 1963942, 1963943, 1963944, 1963945, 1963946, 1963947, 1963948, 1963949, 1963950, 1963951, 1963952, 1963953, 1963961, 1963962, 1963963, 1963973, 1963974, 1963975, 1963976, 1963978, 1963979, 1963984, 1963985, 1963992, 1963993, 1963994, 1963996, 1964000, 1964001, 1964003, 1973139, 1973140, 1973141, 1973142, 1973143, 1973144, 1973145, 1973146, 1973147, 1973150, 1973151, 1973152, 1973153, 1973156, 1973159, 1973160, 1973162, 1973163, 1973164, 1973165, 1973166, 1973169, 1973170, 1973171, 1973172, 1973173, 1973174, 1973175, 1973179, 1973180, 1973181, 1973182, 1973183, 1973184, 1973199, 1973200, 1973202, 1973203, 1973208, 1973210, 1973211, 1973212, 1973213];

        if (brand.id && radissonSwitzerlandBrandIds.indexOf(parseInt(brand.id)) > -1) {
            return 'CHF';
        }

        if (brand.team_live_country_code === 'DK') {
            return 'kr. ';
        }

        if (brand.team_live_country_code === 'PH') {
            return '₱';
        }

        if (brand.team_live_country_code === 'UK') {
            return '£';
        }

        var countryCode;
        var locations = brand.Location || brand.locations || [];
        var location = locations[0] || {};
        var country = location['country_code'] || location['Country'] || location['country'];

        if (typeof country === "string") {
            countryCode = country;
        } else if (country && country['code']) {
            countryCode = country['code'];
        }

        if (countryCode) {
            if (['UK', 'JE', "GG", 'GB'].indexOf(countryCode) > -1) {
                return '£';
            } else if (countryCode == 'AE') {
                return "AED";
            } else if (countryCode === 'DK') {
                return 'kr. ';
            } else if (countryCode === 'PH') {
                return '₱';
            }
            else {
                var GoogleCountryCodes;
                if (typeof(window) === 'undefined') {
                    var path = require("path");
                    GoogleCountryCodes = require(path.resolve(__dirname) + "/GoogleCountryCodes.js");
                }
                else {
                    GoogleCountryCodes = window.GoogleCountryCodes;
                }

                if (GoogleCountryCodes[countryCode] && GoogleCountryCodes[countryCode] == 'Europe' ) {
                    return '€';
                }
            }
        }

    }

    return '$';
};

Utils.loadFacebookPixel = function(f, b, e, v, n, t, s) {
    f = window;
    b = document;
    e = 'script';
    v = 'https://connect.facebook.net/en_US/fbevents.js';
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    fbq('init', EnvironmentsConfig.get('FacebookPixelId'))
};

Utils.trackFacebookPixel = function () {
    try {
        Utils.loadFacebookPixel();
        fbq('track', 'AddToCart');
    } catch (e) {
        console.log(e);
    }
};

Utils.htmlEntities = function (str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

Utils.getNowInBrandTimezoneByTimeZoneName = function (timeZoneName) {
    return moment().tz(timeZoneName);
};

Utils.getTimeInBrandTimezoneByTimeZoneName = function (time, timeZoneName) {
    return moment(time).tz(timeZoneName);
}

Utils.getDurationBetweenDates = function (startDate, endDate) {
    if (!startDate) {
        return '';
    }

    var start = moment(startDate);
    var end = endDate? moment(endDate): moment();
    var differenceInMilliseconds = end.diff(start);
    var duration = moment.duration(differenceInMilliseconds);
    var durationParts = [];

    if (duration.years() > 1) {
        durationParts.push(duration.years() + ' ' + $filter("translate")('Years'));
    } else if (duration.years() === 1) {
        durationParts.push(duration.years() + ' ' + $filter("translate")('Year'));
    }

    if (duration.months() > 1) {
        durationParts.push(duration.months() + ' ' + $filter("translate")('Months'))
    } else if (duration.months() === 1) {
        durationParts.push(duration.months() + ' ' + $filter("translate")('Month'))
    }

    if (duration.days() > 1) {
        durationParts.push(duration.days() + ' ' + $filter("translate")('Days'))
    } else if (duration.days() === 1) {
        durationParts.push(duration.days() + ' ' + $filter("translate")('Day'))
    }

    return durationParts.join(', ');
};

Utils.maintenancePageCheck = function ($state) {
    if ($state.current.name === 'maintenance') {
        var previousPage = HStorageManager.get({
            key: 'pre_maintenance',
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
        });

        if (!previousPage || previousPage.indexOf("/maintenance") > -1) {
            Utils.redirectToWorkspace("homepage");
        }
        else {
            hRedirect(previousPage);
        }

        HStorageManager.remove({
            key: 'pre_maintenance',
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
        })

        return true;
    }

    return false;
};

Utils.addAnonymousUserIndicator = function ($element) {
    if ($($element).find(".anonymous-icon-container").length) {
        $($element).find(".anonymous-icon-container").remove();
        $($element).append("<div class='anonymous-icon-container' title='Private mode'><img class='anonymous-icon' src='images/schedule/anonymous_icon.svg' alt='Private mode'></div>");
    }
    if ($($element).find(".anonymous-icon-container").length === 0) {
        $($element).append("<div class='anonymous-icon-container' title='Private mode'><img class='anonymous-icon' src='images/schedule/anonymous_icon.svg' alt='Private mode'></div>");
    }
};

Utils.addMinorIndicator = function ($element) {
    if ($($element).find(".minor-icon-container").length) {
        $($element).find(".minor-icon-container").remove();
        $($element).append("<div class='minor-icon-container'><div class='minor-icon'>-18</div></div>");
    }
    if ($($element).find(".minor-icon-container").length === 0) {
        $($element).append("<div class='minor-icon-container'><div class='minor-icon'>-18</div></div>");
    }
};

Utils.addLactationBreakIndicator = function ($element) {
    if ($($element).find(".lactation-break-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".lactation-break-icon-container").remove();
       $($element).append("<div class='lactation-break-icon-container'><img class='lactation-break-icon' src='images/lactation-break/lactation_break_icon.svg' title='Lactation Period'></div>");
    }

    if ($($element).find(".lactation-break-icon-container").length === 0) {
        $($element).append("<div class='lactation-break-icon-container'><img class='lactation-break-icon' src='images/lactation-break/lactation_break_icon.svg' title='Lactation Period'></div>");
    }
};

Utils.addVSLOptInIndicator = function ($element) {
    if ($($element).find(".vsl-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".vsl-icon-container").remove();
        $($element).append("<div class='vsl-icon-container'><div class='vsl-icon' title='Voluntary Standby List'>v</div></div>");
    }

    if ($($element).find(".vsl-icon-container").length === 0) {
        $($element).append("<div class='vsl-icon-container'><div class='vsl-icon' title='Voluntary Standby List'>v</div></div>");
    }
};

Utils.addLoaIndicator = function ($element) {
    if ($($element).find(".loa-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".loa-icon-container").remove();
        $($element).append("<div class='loa-icon-container'><div class='loa-icon'>LOA</div></div>");
    }

    if ($($element).find(".loa-icon-container").length === 0) {
        $($element).append("<div class='loa-icon-container'><div class='loa-icon'>LOA</div></div>");
    }
};

Utils.addWorkVisaIndicator = function ($element) {
    if ($($element).find(".work-visa-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".work-visa-icon-container").remove();
        $($element).append("<div class='work-visa-icon-container'><img class='work-visa-icon' src='images/people-pletform/work_visa.svg' title='Work Visa'></div>");
    }

    if ($($element).find(".work-visa-icon-container").length === 0) {
        $($element).append("<div class='work-visa-icon-container'><img class='work-visa-icon' src='images/people-pletform/work_visa.svg' title='Work Visa'></div>");
    }
};

Utils.addManagerIndicator = function ($element) {
    if ($($element).find(".manager-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".manager-icon-container").remove();
        $($element).append("<div class='manager-icon-container'><div class='manager-icon' title='Manager'>M</div></div>");
    }

    if ($($element).find(".manager-icon-container").length === 0) {
        $($element).append("<div class='manager-icon-container'><div class='manager-icon' title='Manager'>M</div></div>");
    }
};

Utils.addSharedLocationIndicator = function ($element) {
    if ($($element).find(".shared-location-icon-container").length && $($element).parents('.employee-info').length) {
        $($element).find(".shared-location-icon-container").remove();
        $($element).append("<div class='shared-location-icon-container'><div class='shared-location-icon' title='Shared'>Sh</div></div>");
    }

    if ($($element).find(".shared-location-icon-container").length === 0) {
        $($element).append("<div class='shared-location-icon-container'><div class='shared-location-icon' title='Shared'>Sh</div></div>");
    }
};

Utils.print = function (docTitle, htmlString, callback) {
    var originalDocumentTitle = document.title;
    document.title = docTitle;

    var printFrame = $('<iframe></iframe>');

    printFrame.attr('src', "about:blank");
    printFrame.css({
        width: '0',
        height: '0',
        opacity: '0',
        position: 'absolute'
    });

    $('body').append(printFrame);

    printFrame[0].contentWindow.document.write(htmlString);
    printFrame[0].contentWindow.document.close();

    setTimeout(function () {
        printFrame.focus();
        printFrame[0].contentWindow.print();
        setTimeout(function () {
            printFrame.remove();
            document.title = originalDocumentTitle;
            callback();
        }, 100)
    }, 100);
};

Utils.minifyHtml = function(html) {
    var minify = '';
    minify = html.replace(/(\r\n|\n|\r)/gm,"");
    minify = minify.replace(/> *</g, '><')
    return minify;
}

Utils.escapeHtml = function (html) {
    html = html || "";

    var entityMap = {
        // Temporary removing & from escaping, because of AtWhoWrapper issues
       // "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': '&quot;',
        "'": '&#39;',
        "/": '&#x2F;'
    };

    var escaped = String(html).replace(/[<>"'\/]/g, function (s) {
        return entityMap[s];
    });

    return escaped;
};

Utils.cookieBlockHandler = function(){
    var allowCookiesBtn = $('.allow-cookies-btn');

    allowCookiesBtn.on('click', function () {
        HStorageManager.put({
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
            key: 'cookies_allowed',
            value: true
        });
        $(this).parent().fadeOut('slow');
        $('body').removeClass('cookies-not-allowed');
    });

    if (HStorageManager.get({
        key: 'cookies_allowed',
        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
    })) {
        allowCookiesBtn.parent().hide();
    }
    else {
        $('body').addClass('cookies-not-allowed');
    }
}

Utils.hCurrency = function (amount, currencySymbol, fractionSize) {
    var amountWithCurrency =  $injector.get('$filter')('currency')(amount, currencySymbol, fractionSize);

    if (amountWithCurrency.indexOf('-') !== -1) {
        return '-' + amountWithCurrency.split('-').join('');
    }
    else {
        return amountWithCurrency;
    }
};

Utils.goToUrl = function (url) {
    const $location = $injector.get('$location');
    const hrefParts = url.split('?');
    const path = hrefParts[0];
    const queryString = hrefParts[1];
    const queryParams = {};

    if (queryString) {
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            queryParams[key] = decodeURIComponent(value);
        });
    }

    $location.path(path).search(queryParams);
}

Utils.compactNumber = function (number, currency) {

    var divider = 1;
    var key = "";
    var fractions = 0;
    number = number || 0;

    if (number >= (1000000)) {
        divider = 1000000;
        key = "M";
        fractions = 2;
    }
    else if (number >= 1000) {
        divider = 1000;
        key = "K";
        fractions = 1;
    }

    var result = Utils.hCurrency((number / divider), (currency || ""), fractions) + key;
    result = result.replace(".00", "");
    if (key) {
        result = result.replace(".0" + key, key);
    }
    return result;
};


Utils.redirectToSupport = function (newTab, return_to_data) {
    GatewayAPI.getZendeskToken()
        .then(function (res) {
            let url = publicConfiguration.ZendeskServer + "/access/jwt";
            let form = $('<form />').attr("method", "POST").attr("action", url);
            $('<input />').attr("type", "hidden").attr("name", "jwt").attr("value", res.jwt).appendTo(form);
            if (return_to_data) {
                $('<input />').attr("type", "hidden").attr("name", "return_to").attr("value", return_to_data).appendTo(form);
            }

            form.appendTo('body');
            form.submit();
        }).catch(function (err) {
        var url = publicConfiguration.ZendeskServer + "/hc/en-us";
        newTab ? window.open(url, "_blank ") : window.open(url, "_self");
    });
};

Utils.redirectToCommunitySupport = function (openInNewTab) {
    GatewayAPI.getExternalToken('COMMUNITY')
        .then((res) => {
            let url = `${publicConfiguration.CommunityServer}?token=${res.jwt}&customer=harri-en`;
            openInNewTab ? window.open(url, "_blank ") : window.open(url, "_self");
        })
        .catch((err) => {
            console.error(err);
            let url = `${publicConfiguration.CommunityServer}?customer=harri-en`;
            openInNewTab ? window.open(url, "_blank ") : window.open(url, "_self");
        });
};


Utils.humanizeoAuthErrorResponse = function(err){
    if (err.indexOf(`RESET_MAX_ATTEMPTS`) > -1) {
        return $filter('translate')(`You have reached the maximum number of password reset attempts`) + '.';
    }

    if( err.indexOf("VALIDATION_EXCEPTION:INVALID_USERNAME_OR_PASSWORD")>-1 ||  err.indexOf("Incorrect username or password.")>-1){
        return $filter("translate")( "Enter the correct email and password.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:GOOGLE_RECAPTCHA_TOKEN_REQUIRED")>-1 || err.indexOf("VALIDATION_EXCEPTION:INVALID_GOOGLE_RECAPTCHA_TOKEN")>-1){
        return $filter("translate")("Something went wrong. Try again.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:INVALID_EMAIL_ADDRESS")>-1){
        return $filter("translate")("Enter the correct email.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:EMAIL_ADDRESS_REQUIRED")>-1){
        return $filter("translate")("Unable to log in/sign up. Email required.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:USER_MISSING_REQUIRED_ATTRIBUTES")>-1){
        return $filter("translate")("To login, you need to add more details to your account. Contact your administrator.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:INVALID_PHONE_NUMBER")>-1){
        return $filter("translate")("Enter the correct phone number.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:INVALID_PREFERRED_USERNAME")>-1){
        return $filter("translate")("Something went wrong. Try again.");
    }

    if( err.indexOf("VALIDATION_EXCEPTION:INVALID_API_KEY")>-1){
        return $filter("translate")("Invalid Client Key");
    }

    if ((err.indexOf("VALIDATION_EXCEPTION:USER_NOT_MAPPED") > -1) || err === "USER_NOT_MAPPED") {
        return $filter("translate")("To complete your account setup, contact support@harri.com, or call us. For US members, call +1.844.427.7443. For UK members, call +44.20.3617.1295");
    }

    if ( err.indexOf("EXTERNAL_BRAND_NOT_MAPPED")>-1){
        return $filter("translate")("These locations aren't registered with your account. Try again, or contact your administrator.");
    }

    if ( err.indexOf("SOME_OF_EXTERNAL_BRAND_ARE_NOT_MAPPED")>-1){
        return $filter("translate")("Some of the location(s) linked to your account are not valid, please contact your administrator.");
    }

    if ( err.indexOf("SOME_OF_EXTERNAL_BRAND_ARE_NOT_MAPPED")>-1){
        return $filter("translate")("Some of the location(s) linked to your account are not valid, please contact your administrator.");
    }

    if ( err.indexOf("USER_PROFILE_MISSING_REQUIRED_ATTRIBUTES")>-1){
        return $filter("translate")("Something went wrong. Try again.");
    }

    if ( err.indexOf("VALIDATION_EXCEPTION:USER_ALREADY_MAPPED")>-1){
        return $filter("translate")("Log in with your registered account. For help, contact support@harri.com.");
    }

    if ( err.indexOf("Invalid phone number format")>-1){
        return $filter("translate")("Invalid phone number format.");
    }

    if ( err.indexOf("NORMAL_SIGN_UP_NOT_ALLOWED")>-1){
        return $filter("translate")("Unable to register, contact our stellar support team here (support@harri.com) " +
                                                  "or dial US: +1.844.427.7443 | UK: +44 800 260 6489");
    }

    // MSIS9619%3A+The+received+request+is+not+authorized+to+access+the+requested+resource.%3B+error%3Daccess_denied&state=BxUJUpMv8MD9PToRCxLQt4W7WCEwxkuz&error=access_denied
    if ( err.indexOf("MSIS9619")>-1){
        return $filter("translate")("You are not authorized to access the requested resource, please contact your administrator.");
    }

    if (err.indexOf("INVALID_CREDENTIALS") > -1) {
        return $filter("translate")("Enter the correct email and password.");
    }

    if (err.indexOf("EXTERNAL_USER_NOT_MAPPED_EXCEPTION") > -1) {
        return $filter("translate")("This username isn't registered. For help, contact your system administrator.");
    }

    if (err.indexOf("DELETED_EXTERNAL_USER") > -1) {
        return $filter("translate")("Your account is deactivated. For help, contact your administrator.");
    }

    if (err.indexOf("SOME_OF_EXTERNAL_BRAND_ARE_NOT_MAPPED") > -1) {
        return $filter("translate")("Some of these locations aren't registered with your account. Try again, or contact your administrator.");
    }

    //equality for errors direct from api, and indexOf("VALIDATION_EXCEPTION:${error}.") for errors returned from AWS or iFrame
    if (err === "EXTERNAL_USER" || (err.indexOf("VALIDATION_EXCEPTION:EXTERNAL_USER.") > -1)) {
        return $filter("translate")("Please reset your password from your enterprise account provider.");
    }

    return $filter("translate")("Something went wrong, please try again later. If the problem persists," +
                                              " contact our stellar support team here (support@harri.com) " +
                                              "or dial US: +1.844.427.7443  |  " +
                                              "UK: +44 800 260 6489");
};

// source of code https://cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api
// center and one of boundaries point
Utils.calculateMileDistance = function(firstPoint, secondPoint) {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = firstPoint.lat * (Math.PI/180); // Convert degrees to radians
    var rlat2 = secondPoint.lat * (Math.PI/180); // Convert degrees to radians
    var difflat = rlat2-rlat1; // Radian difference (latitudes)
    var difflon = (secondPoint.lng-firstPoint.lng) * (Math.PI/180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
    return d;
};

Utils.openWindow = async (getUrlAsync, isNewTab = true) => {
    const target = isNewTab ? '_blank' : '_self';
    const w = window.open('', target);
    if (w) {
        const url = await getUrlAsync();
        w.location.href = url;
    } else {
        throw new Error('Popup window was blocked by the browser.');
    }
};


Utils.hexToRGB = function (hexColor) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};

Utils.formatDateWithTimezoneAbbr = function (date, brandTimeZone, options, locale) {
    if (!options || !Object.keys(options).length) {
        // default format (may vary based on locale) 'DD MMM YYYY,  HH:mm:ss z' or 'MMM DD, YYYY,  HH:mm:ss z'
        options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: brandTimeZone,
            timeZoneName: 'short',
            hour12: false,
        }
    }

    if (!locale) {
        locale = 'default';
    }

    return new Intl.DateTimeFormat(locale, options).format(date);
}

Utils.debounce = (func, wait) => {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

Utils.latestRequest = (fn) => {
    let latestTimestamp = 0;

    return function (...args) {
        const requestTimestamp = ++latestTimestamp;

        return new Promise((resolve, reject) => {
            fn(...args)
                .then(res => {
                    if (requestTimestamp === latestTimestamp) {
                        resolve(res);
                    }
                })
                .catch(err => {
                    if (requestTimestamp === latestTimestamp) {
                        reject(err);
                    }
                })
        });
    };
}

Utils.redirectToWorkspace = function (state, params) {
    const $state = $injector.get('$state');
    window.location.href = $state.href(state, params, {absolute: true});
}

/**
 * Dynamically loads a JavaScript file into the document and provides a promise-based mechanism
 * to handle the script's loading status. Ensures that the script is loaded only once and allows
 * for cleanup after execution.
 *
 * @param {Object} config - Configuration object for loading the script.
 * @param {string} config.url - The URL of the script to load.
 * @param {Object} [config.queryParams] - Optional query parameters to append to the script URL.
 * @param {boolean} [config.async=true] - Whether the script should be loaded asynchronously.
 * @param {boolean} [config.defer=true] - Whether the script should be deferred.
 * @param {Object} [config.tagAttributes] - Optional attributes to set on the `<script>` tag.
 *
 * @returns {Promise<Function>} A promise that resolves with a cleanup function to remove the script
 * from the DOM or rejects with an error object if the script fails to load.
 */
Utils.loadScript = (config) => {

    const cleanupScript = (script) => {
        if (script) {
            script.onload = null;
            script.onerror = null;
            document?.head.removeChild(script);
        }
    };

    return new Promise((resolve, reject) => {

        const queryParams = new URLSearchParams();
        Object.keys(config.queryParams ?? {}).forEach(key => {
            queryParams.append(key, config.queryParams[key]);
        });
        const src = `${config.url}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

        let script= document?.querySelector(`script[src="${src}"]`);

        if (script) {
            const status = script.getAttribute('data-status');
            if (status === 'ready') {
                return resolve(() => cleanupScript(script));
            } else if (status === 'loading') {
                script.addEventListener('load', () => resolve(() => cleanupScript(script)));
                script.addEventListener('error', () =>
                    reject(new Error(`Failed to load script: ${src}`))
                );
                return;
            }
            resolve(
                () => {
                    cleanupScript(script);
                }
            );
        }

        script = document?.createElement('script');
        script.src = src;
        script.async = config.async ?? true;
        script.defer = config.defer ?? true;
        script.setAttribute('data-status', 'loading');

        Object.keys(config.tagAttributes ?? {}).forEach(key => {
            script?.setAttribute(key, config.tagAttributes[key]);
        });
        Object.keys(config.queryParams ?? {}).forEach(key => {
            queryParams.append(key, config.queryParams[key]);
        });

        script.onload = (event) => {
            if (script) {
                script.setAttribute('data-status', 'ready');
            }
            resolve(
                () => {
                    cleanupScript(script);
                }
            );
        };

        script.onerror = (event, source, lineno, colno, error) => {
            if (script) {
                script.setAttribute('data-status', 'error');
            }
            reject({
                event, source, lineno, colno, error
            })
        };

        document?.head.appendChild(script);
    });
}